export enum LIBRARY_TYPE {
  YEARS70,
  YEARS80,
  YEARS90,
  YEARS00,
  YEARS10,
  COLLECTION,
}
